import axios from "axios";
import Cookies from "js-cookie";
import router from "@/router";
import { captureException } from "@/plugins/sentry";

const getToken = () => {
  const access_token = Cookies.get("g_at");
  const refresh_token = Cookies.get("g_rt");

  return { access_token, refresh_token };
};

const setToken = ({ access_token, refresh_token }) => {
  Cookies.set("g_at", access_token);
  Cookies.set("g_rt", refresh_token);
  axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
};

const clearToken = () => {
  Cookies.remove("g_at");
  Cookies.remove("g_rt");
  axios.defaults.headers.common["Authorization"] = null;
};

const responseInterceptor = (error) => {
  const status = error.response?.status;

  if (status === 401) {
    clearToken();
    router.push({ name: "Login" });

    return Promise.reject(error);
  }

  // Peticiones canceladas (el usuario navego a otra vista): no son fallos
  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }

  // Solo se reportan errores del servidor o de red; los 4xx restantes son
  // validaciones esperadas que maneja cada vista.
  if (!status || status >= 500) {
    const method = (error.config?.method || "GET").toUpperCase();
    const url = error.config?.url || "desconocida";

    // Se reporta con un mensaje propio para que Sentry agrupe por endpoint
    // en lugar de juntar todo bajo un unico "Network Error".
    const reported = new Error(
      `API ${method} ${url} fallo (${status || "sin respuesta"}): ${
        error.message
      }`
    );
    reported.stack = error.stack;

    captureException(reported, {
      url,
      method,
      status: status || "network_error",
      response: error.response?.data,
    });
  }

  return Promise.reject(error);
};

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.interceptors.response.use((response) => response, responseInterceptor);

export { axios, getToken, setToken, clearToken };
